import { render, staticRenderFns } from "./shippingInformation.vue?vue&type=template&id=5083c0ff&scoped=true&"
import script from "./shippingInformation.vue?vue&type=script&lang=js&"
export * from "./shippingInformation.vue?vue&type=script&lang=js&"
import style0 from "./shippingInformation.vue?vue&type=style&index=0&id=5083c0ff&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083c0ff",
  null
  
)

export default component.exports